// utils/refundCalculations.js
export const getAddonTotalPrice = (addon) => {
  if (!addon || typeof addon !== "object") return 0;
  let price = parseFloat(addon.totalPrice || 0);
  if (addon.options && Array.isArray(addon.options)) {
    addon.options.forEach((option) => {
      price += parseFloat(option.totalPrice || 0);
      if (option.subOptions && Array.isArray(option.subOptions)) {
        option.subOptions.forEach((sub) => {
          price += parseFloat(sub.totalPrice || 0);
        });
      }
    });
  }
  return price;
};

export const getRefundableAddonPrices = (addons, selectedAddonsIds) => {
  if (!addons || !Array.isArray(addons)) return 0;
  return addons
    .filter((ad) => ad.refundStatus !== "Refunded")
    .filter((ad) => selectedAddonsIds.includes(ad.id))
    .reduce((sum, ad) => sum + getAddonTotalPrice(ad), 0);
};

export const getRefundableItemPrices = (item, refundQty, order) => {
  const unitPrice =
    parseFloat(item.basePrice || 0) +
    parseFloat(item.vatInAmount || 0) +
    parseFloat(item.sdInAmount || 0);

  const itemPrice = unitPrice * refundQty;

  const itemMisedTips =
    item.tips != 0 ? parseFloat(item.remainingTips || 0) / item.qty : 0;
  const itemMisedSC =
    item.serviceCharge != 0
      ? parseFloat(item.remainingServiceCharge || 0) / item.qty
      : 0;
  const itemMisedSCVat =
    item.serviceChargeVat != 0
      ? parseFloat(item.remainingServiceChargeVAT || 0) / item.qty
      : 0;

  const itemTips =
    item.qty === refundQty
      ? parseFloat(item.remainingTips || 0)
      : itemMisedTips * refundQty;

  const itemSC =
    item.qty === refundQty
      ? parseFloat(item.remainingServiceCharge || 0)
      : itemMisedSC * refundQty;

  const itemSCVat =
    item.qty === refundQty
      ? parseFloat(item.remainingServiceChargeVAT || 0)
      : itemMisedSCVat * refundQty;

  return {
    itemPrice: itemPrice.toFixed(2),
    itemTips: itemTips.toFixed(2),
    itemSC: itemSC.toFixed(2),
    itemSCVat: itemSCVat.toFixed(2),
  };
};

export const getRefundableAddonAmounts = (
  addonPrices,
  order,
  selectedAddons,
  itemAddons
) => {
  const totalItemPrice = parseFloat(order.totalItemPrice || 0);
  const totalTips = parseFloat(order.totalTips || 0);
  const totalSC = parseFloat(order.totalServiceCharge || 0);
  const totalSCVat = parseFloat(order.totalServiceChargeVat || 0);

  console.log("Khalid selectedAddons", selectedAddons);
  console.log("Khalid itemAddons", itemAddons);
  console.log("Khalid addonPrices", addonPrices);
  const addonTips = selectedAddons
    .filter((x) => x.remainingTips > 0)
    .reduce((sum, x) => sum + x.remainingTips, 0);
  const addonSC = selectedAddons
    .filter((x) => x.remainingServiceCharge > 0)
    .reduce((sum, x) => sum + x.remainingServiceCharge, 0);
  const addonSCVat = selectedAddons
    .filter((x) => x.remainingServiceChargeVAT > 0)
    .reduce((sum, x) => sum + x.remainingServiceChargeVAT, 0);
  //totalItemPrice > 0 ? (addonPrices / totalItemPrice) * totalSCVat : 0;
  return {
    addonTips: addonTips.toFixed(2),
    addonSC: addonSC.toFixed(2),
    addonSCVat: addonSCVat.toFixed(2),
  };
};

export const getRefundTotalForItem = (
  item,
  refundQty,
  selectedAddons,
  order
) => {
  const { itemPrice, itemTips, itemSC, itemSCVat } = getRefundableItemPrices(
    item,
    refundQty,
    order
  );

  const selectedAddonsIds = selectedAddons.map((a) => a.id);
  const addonPrices = getRefundableAddonPrices(
    item.addons || [],
    selectedAddonsIds
  );
  const { addonTips, addonSC, addonSCVat } = getRefundableAddonAmounts(
    addonPrices,
    order,
    selectedAddons,
    item.addons
  );
  const toNum = (v) => parseFloat(v || 0);

  const total =
    toNum(itemPrice) +
    toNum(itemTips) +
    toNum(itemSC) +
    toNum(itemSCVat) +
    toNum(addonPrices) +
    toNum(addonTips) +
    toNum(addonSC) +
    toNum(addonSCVat);

  const totalFormatted = total.toFixed(2);

  return {
    itemPrice,
    itemTips,
    itemSC,
    itemSCVat,
    addonPrices,
    addonTips,
    addonSC,
    addonSCVat,
    total: totalFormatted,
  };
};

export const calculateTotalRefundAmount = (
  items,
  order,
  getRefundQty,
  getSelectedAddons
) => {
  return items
    .reduce((total, item) => {
      const refundQty = getRefundQty(item);
      const selectedAddons = getSelectedAddons(item);

      const { total: itemTotal } = getRefundTotalForItem(
        item,
        refundQty,
        selectedAddons,
        order
      );

      return total + parseFloat(parseFloat(itemTotal).toFixed(2));
    }, 0)
    .toFixed(2);
};
